"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fontStyle: "bold",
    fontVariant: "bold",
    fontWeight: "bold",
    fontStretch: "normal",
    fontSize: "10.5154705px",
    fontFamily: "Lucida Sans Unicode",
    letterSpacing: "0px",
    wordSpacing: "0px",
    fill: "currentColor",
    fillOpacity: "1",
    stroke: "none",
    strokeWidth: "2",
    id: "text8435",
    transform: "matrix(0.73524342,0,0,0.69556927,7.3067348,15.556293)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M 0.45572897,9.5900892 V 8.3441163 q 1.49756353,0.6948695 2.46798473,0.6948695 0.7368013,0 1.1860704,-0.3893665 0.4552593,-0.3953568 0.4552593,-1.0243335 0,-0.5211521 -0.2995127,-0.8865576 Q 3.9720082,6.3733227 3.1753044,5.9240536 L 2.5642985,5.5706286 Q 1.4321404,4.9236812 0.96490058,4.354607 0.50365101,3.7795426 0.50365101,3.0247706 q 0,-1.0303238 0.74279149,-1.6892517 0.7427916,-0.66491825 1.8929204,-0.66491825 1.0243334,0 2.1624817,0.34144445 V 2.162174 Q 3.9001252,1.6110706 3.2112459,1.6110706 q -0.6529377,0 -1.0782457,0.3474347 -0.4253081,0.3474348 -0.4253081,0.8745771 0,0.4432788 0.3114932,0.7847233 0.3114932,0.3414445 1.1381483,0.8146746 l 0.634967,0.3594153 q 1.1501288,0.6529377 1.6053881,1.2339923 0.4552593,0.5810547 0.4552593,1.3957293 0,1.156119 -0.8506161,1.8569788 -0.8506161,0.7008597 -2.2583258,0.7008597 -0.8985381,0 -2.28827713,-0.3893665 z",
      fontStyle: "bold",
      fontVariant: "bold",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "12.26804066px",
      fontFamily: "Lucida Sans Unicode",
      strokeWidth: "2",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      id: "path8994"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "m 15.485277,11.530932 q -2.090599,-0.676899 -3.504299,-1.6113788 -0.563084,0.059903 -0.868587,0.059903 -1.7850955,0 -2.905273,-1.2938949 -1.1141873,-1.2938949 -1.1141873,-3.3605326 0,-2.12055 1.1261678,-3.3844937 1.1321581,-1.26993385 3.0190885,-1.26993385 1.89292,0 3.019088,1.26993385 1.126168,1.2699339 1.126168,3.4024644 0,3.0550297 -2.270307,4.2291195 1.527515,0.6709091 3.168845,0.9584401 z m -4.24709,-2.4919462 q 1.323846,0 2.066637,-0.9824017 0.742792,-0.9824017 0.742792,-2.7315559 0,-1.7551445 -0.742792,-2.7315559 -0.742791,-0.9824017 -2.066637,-0.9824017 -1.3238466,0 -2.0666381,0.9824017 -0.7427915,0.9764114 -0.7427915,2.7195754 0,1.7551445 0.7427915,2.7435364 0.7427915,0.9824017 2.0666381,0.9824017 z",
      fontStyle: "bold",
      fontVariant: "bold",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "12.26804066px",
      fontFamily: "Lucida Sans Unicode",
      strokeWidth: "2.0999999",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      id: "path8996"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M 17.150567,9.7578163 V 0.89224006 H 18.40852 V 8.8173464 h 3.98951 v 0.9404699 z",
      fontStyle: "bold",
      fontVariant: "bold",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "12.26804066px",
      fontFamily: "Lucida Sans Unicode",
      strokeWidth: "2",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      id: "path8998"
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    id: "g8449",
    transform: "matrix(2.0561272,0,0,2.0561272,-28.511292,-15.219679)",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
      id: "text8439",
      y: "15.552015",
      x: "15.957305",
      fontStyle: "bold",
      fontWeight: "bold",
      fontSize: "12px",
      fontFamily: "sansSerif",
      letterSpacing: "0px",
      wordSpacing: "0px",
      fill: "currentColor",
      fillOpacity: "1",
      stroke: "none",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("tspan", {
        fontStyle: "bold",
        fontVariant: "bold",
        fontWeight: "bold",
        fontStretch: "normal",
        fontSize: "12px",
        fontFamily: "Gabriola",
        y: "15.552015",
        x: "15.957305",
        id: "tspan8437",
        children: "f"
      })
    })
  })]
}));